import { createSystem, defaultConfig } from '@chakra-ui/react'
import { darkColors, lightColors, semanticTokens } from './colors'
import { components } from './components'
import {
  animations,
  badge,
  borders,
  breakpoints,
  button,
  card,
  dialog,
  emptyState,
  form,
  layout,
  menu,
  navigation,
  radii,
  ring,
  semanticSpacing,
  shadows,
  spacing,
  table,
  toast,
  zIndices,
} from './foundations'

// Combine all application UI constants into single object for easier import
export const uit = {
  layout,
  navigation,
  menu,
  badge,
  card,
  dialog,
  table,
  form,
  button,
  animations,
  borders,
  ring,
  emptyState,
  toast,
  spacing: semanticSpacing, // Use semantic names for clarity
}

// Chakra UI v3 system configuration
const system = createSystem(defaultConfig, {
  // Color mode config
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },

  // Colors
  colors: {
    ...lightColors,
    // Chakra will automatically handle dark mode variants
  },

  // Semantic tokens (color mode aware)
  semanticTokens,

  // Breakpoints
  breakpoints,

  // Spacing
  space: spacing,

  // Border radius
  radii,

  // Shadows
  shadows,

  // Z-index
  zIndices,

  // Fonts
  fonts: {
    heading: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    body: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    mono: 'Menlo, Monaco, Consolas, "Courier New", monospace',
  },

  // Font sizes
  fontSizes: {
    xs: '0.75rem',
    sm: '0.875rem',
    md: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '1.875rem',
    '4xl': '2.25rem',
    '5xl': '3rem',
    '6xl': '3.75rem',
  },

  // Font weights
  fontWeights: {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },

  // Line heights
  lineHeights: {
    none: 1,
    tight: 1.25,
    snug: 1.375,
    normal: 1.5,
    relaxed: 1.625,
    loose: 2,
  },

  // Component styles
  components,

  // Global styles
  styles: {
    global: (props) => ({
      body: {
        bg: props.colorMode === 'dark' ? darkColors.bg.primary : lightColors.bg.primary,
        color: props.colorMode === 'dark' ? darkColors.text.primary : lightColors.text.primary,
      },
      '*::placeholder': {
        color: props.colorMode === 'dark' ? darkColors.text.tertiary : lightColors.text.tertiary,
      },
    }),
  },
})

export default system
